import React, { useState } from "react";
import "../../assets/Css/ProductDetails.css";
import Outlet from "../Outlet";
import Breadcrumb from "../Breadcrumb";
import { IoLocationOutline } from "react-icons/io5";
import { useLocation, useParams } from "react-router-dom";

const ProductDetails = () => {
  const { id } = useParams();

  const location = useLocation();
  const data = location.state || {};
  const product = data.product;

  // ✅ MAIN IMAGE STATE
  const [mainImage, setMainImage] = useState(
    product?.images?.[0]
  );

  if (!product) {
    return <div className="error">Product not found</div>;
  }

  return (
    <Outlet>
      <div className="dashboard-headera">
        <div className="dashboard-title">
          <h2 className="dashboard-title">Dashboard</h2>
        </div>
        <Breadcrumb />
      </div>

      <div className="product-details-container">
        {/* Left Side - Images */}
        <div className="product-images">
          <div className="main-image">
            <img
              className="main-img"
              src={mainImage}
              alt={product.title}
            />
          </div>

          <div className="thumbnail-row">
            {product.images?.map((img, index) => (
              <div
                key={index}
                className={`thumbnail ${mainImage === img ? "active" : ""
                  }`}
                onClick={() => setMainImage(img)}
              >
                <img src={img} alt={`${product.title} ${index + 1}`} />
              </div>
            ))}
          </div>
        </div>

        {/* Right Side - Details */}
        <div className="product-info">
          <h2 className="product-title">{product.title}</h2>

          <p className="product-desc">
            {product.description}
            <span className="see-more"> See more</span>
          </p>

          <h4 className="price-label">Price</h4>
          <div className="price">
            <span className="new-price">₹{product.price}</span>
            {product.discountPrice && (
              <span className="old-price">
                ₹{product.discountPrice}
              </span>
            )}
          </div>

          <div className="location">
            <IoLocationOutline />
            {` ${product.location?.address},
              ${product.location?.area},
              ${product.location?.city},
              ${product.location?.state},
              ${product.location?.country} - 
              ${product.location?.zipCode}`}
          </div>
        </div>
      </div>
    </Outlet>
  );
};

export default ProductDetails;
